export default __webpack_public_path__ + "static/media/cloud_dayTime.0a83a95d.svg";